import { type ReactNode } from 'react';
import Nav from 'react-bootstrap/Nav';

interface TabNavProps {
  children: ReactNode;
  testId?: string | null;
}

const TabNav = ({ children, testId = null }: TabNavProps) => (
  <Nav className="nav-header" data-testid={testId}>
    <div className="nav-wrapper">{children}</div>
  </Nav>
);

export default TabNav;
